import React from 'react';
import Link from '@material-ui/core/Link';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { LINE_HEIGHT, SPACES } from 'common/constants/sizes';

const GoalDisabled = ({ setGoalText, setGoalLink }) => {
  return (
    <Flex direction='column' data-testid='goal-not-set'>
      <Text size='medium' weight='700' pb='0.3rem' color='shuttleGray'>
        Goal not set
      </Text>
      <Text
        size='medium'
        pb='0.3rem'
        color='shuttleGray'
        lineHeight={LINE_HEIGHT.medium}
      >
        {setGoalText}
      </Text>
      <Text size='medium' pt='1rem'>
        <Link onClick={setGoalLink}>Set Up Goal</Link>
      </Text>
    </Flex>
  );
};

const GoalEnabled = ({
  colorName,
  textColorName,
  percent,
  prsMergedSum,
  didNotMeetSum,
  didNotMeetGoalTooltipDescription
}) => {
  return (
    <Flex direction='column' data-testid='goal-set'>
      <Flex pb='x-small'>
        <Text
          size='medium'
          weight='700'
          pr='0.5rem'
          color={textColorName || colorName}
          data-testid='goal-percent'
        >
          {prsMergedSum === 0 ? '-' : `${percent}%`}
        </Text>
        <Text size='medium' color='shuttleGray'>
          met goal
        </Text>
      </Flex>
      <Flex pb='x-small'>
        <Text size='medium' color='shuttleGray' weight='700' pr='0.5rem'>
          {prsMergedSum}
        </Text>
        <Text size='medium' color='shuttleGray'>
          PRs merged
        </Text>
      </Flex>
      <Flex pb='x-small'>
        <Text size='medium' color='shuttleGray' weight='700' pr='0.5rem'>
          {didNotMeetSum}
        </Text>
        <Text size='medium' color='shuttleGray'>
          {didNotMeetGoalTooltipDescription}
        </Text>
      </Flex>
    </Flex>
  );
};

const GoalsTooltip = ({
  name,
  percent,
  setGoalText,
  setGoalLink,
  colorName,
  textColorName,
  prsMergedSum,
  didNotMeetSum,
  didNotMeetGoalTooltipDescription
}) => {
  return (
    <Flex
      direction='column'
      padding='small'
      width='32rem'
      data-testid='goal-tooltip'
    >
      <Text
        size='x-medium'
        letterSpacing='0.4px'
        textTransform='uppercase'
        pb={SPACES.small}
        data-testid='goal-tooltip-name'
      >
        {name}
      </Text>

      {setGoalText ? (
        <GoalDisabled setGoalText={setGoalText} setGoalLink={setGoalLink} />
      ) : (
        <GoalEnabled
          colorName={colorName}
          textColorName={textColorName}
          percent={percent}
          prsMergedSum={prsMergedSum}
          didNotMeetSum={didNotMeetSum}
          didNotMeetGoalTooltipDescription={didNotMeetGoalTooltipDescription}
        />
      )}
    </Flex>
  );
};

export default GoalsTooltip;
